module.exports = __webpack_public_path__ + "static/Operationen-Zweitmeinung (unsplash)-min-f3764a7f23c8c6655059319d9948c565.jpg";